module.exports = __webpack_public_path__ + "img/emo_41.2bcafc8c.png";